import styled, { css } from 'styled-components';
import { Color } from 'src/utils/theme';

export const Container = styled.div<{
  $backgroundColor: Color;
  $invertTextColor?: boolean;
}>(
  ({ theme, $backgroundColor, $invertTextColor }) => css`
    background-color: ${theme.co[$backgroundColor]};
    padding: ${theme.sz.s8} ${theme.sz.s0};
    box-shadow: 0 0 0 100vmax ${theme.co[$backgroundColor]};
    clip-path: inset(0 -100vmax);
    border-top-right-radius: ${theme.bo.medium};
    border-bottom-right-radius: ${theme.bo.medium};

    ${
      $invertTextColor &&
      css`
        color: ${theme.co.neutral99};
      `
    };

    @media (min-width: ${theme.sz.lg}) {
      box-shadow: 0 ${theme.sz.s1} ${theme.sz.s1} 0 rgba(0, 0, 0, 0.25);
      clip-path: unset;
      margin-left: calc(-100vw / 2);
      padding: ${theme.sz.s8} ${theme.sz.s0} ${theme.sz.s8} calc(100vw / 2);
    }
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    max-width: ${theme.sz.md};
    margin: auto;
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    margin: unset;
    ${theme.typography.heading.mobile.l};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xl};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s4};
    ${theme.typography.paragraph.base};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.l};
    }
  `,
);
